/** Normalize manifest `materials` (string or string[]) for chip display. */
export function normalizeMaterials(
  materials: string | readonly string[] | undefined
): readonly string[] {
  if (materials === undefined) return []
  if (Array.isArray(materials)) {
    return materials.map((s: string) => s.trim()).filter(Boolean)
  }
  if (typeof materials === 'string') {
    // Support either a comma list ("Walnut, maple") or a simple "and" list ("Purpleheart and maple").
    // For anything more complex, prefer the array form in the manifest.
    return materials
      .split(/\s*,\s*|\s+and\s+/i)
      .map((s: string) => s.trim())
      .filter(Boolean)
  }
  return []
}
